module.exports = __webpack_public_path__ + "img/健康检测设备.e79d9a96.png";